import { Core } from "@faire/design-tokens";
import { localNum } from "@faire/web--source/common/localization";
import { Star } from "@faire/web--source/slate/icons/foundation/Star";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { IBrandReviewsSummary } from "@faire/web-api--source/indigofair/data/IBrandReviewsSummary";
import round from "lodash/round";
import React from "react";
import styled from "styled-components";

interface IProps {
  brandReviewSummary: IBrandReviewsSummary;
}

export const BrandRating = ({
  brandReviewSummary: { average_rating, number_of_reviews },
}: IProps) => {
  return (
    <Row align="center">
      <Star fontSize="14px" fill={Core.icon.default} />
      <Spacer width={4} />
      <Row>
        <Typography>{localNum(round(average_rating ?? 0, 1))}</Typography>
        <Spacer width={4} />
        <Typography>(</Typography>
        <UnderlineText>{localNum(number_of_reviews)}</UnderlineText>
        <Typography>)</Typography>
      </Row>
    </Row>
  );
};

const UnderlineText = styled(Typography)`
  text-decoration: underline;
`;
